/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiRoamingFaqGet } from '../fn/urls/api-roaming-faq-get';
import { ApiRoamingFaqGet$Params } from '../fn/urls/api-roaming-faq-get';
import { apiRoamingHowtoUrlsGet } from '../fn/urls/api-roaming-howto-urls-get';
import { ApiRoamingHowtoUrlsGet$Params } from '../fn/urls/api-roaming-howto-urls-get';
import { apiRoamingMobilepublicofferurlGet } from '../fn/urls/api-roaming-mobilepublicofferurl-get';
import { ApiRoamingMobilepublicofferurlGet$Params } from '../fn/urls/api-roaming-mobilepublicofferurl-get';
import { apiRoamingMukUrlsGet } from '../fn/urls/api-roaming-muk-urls-get';
import { ApiRoamingMukUrlsGet$Params } from '../fn/urls/api-roaming-muk-urls-get';
import { apiRoamingPrivacypolicyurlGet } from '../fn/urls/api-roaming-privacypolicyurl-get';
import { ApiRoamingPrivacypolicyurlGet$Params } from '../fn/urls/api-roaming-privacypolicyurl-get';
import { apiRoamingPublicofferurlGet } from '../fn/urls/api-roaming-publicofferurl-get';
import { ApiRoamingPublicofferurlGet$Params } from '../fn/urls/api-roaming-publicofferurl-get';
import { apiRoamingWhatsnewurlGet } from '../fn/urls/api-roaming-whatsnewurl-get';
import { ApiRoamingWhatsnewurlGet$Params } from '../fn/urls/api-roaming-whatsnewurl-get';
import { MukUrlApiRoaming } from '../models/muk-url-api-roaming';

@Injectable({ providedIn: 'root' })
export class ApiRoamingUrlsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiRoamingPublicofferurlGet()` */
  static readonly ApiRoamingPublicofferurlGetPath = '/api/Roaming/publicofferurl';

  /**
   * Obtaining a link to a public offer for the specified application type and language.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingPublicofferurlGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingPublicofferurlGet$Response(params?: ApiRoamingPublicofferurlGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiRoamingPublicofferurlGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtaining a link to a public offer for the specified application type and language.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingPublicofferurlGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingPublicofferurlGet(params?: ApiRoamingPublicofferurlGet$Params, context?: HttpContext): Observable<string> {
    return this.apiRoamingPublicofferurlGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiRoamingMobilepublicofferurlGet()` */
  static readonly ApiRoamingMobilepublicofferurlGetPath = '/api/Roaming/mobilepublicofferurl';

  /**
   * Obtaining a link to a public offer for mobile payments for the specified application type and language.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingMobilepublicofferurlGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingMobilepublicofferurlGet$Response(params?: ApiRoamingMobilepublicofferurlGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiRoamingMobilepublicofferurlGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtaining a link to a public offer for mobile payments for the specified application type and language.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingMobilepublicofferurlGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingMobilepublicofferurlGet(params?: ApiRoamingMobilepublicofferurlGet$Params, context?: HttpContext): Observable<string> {
    return this.apiRoamingMobilepublicofferurlGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiRoamingPrivacypolicyurlGet()` */
  static readonly ApiRoamingPrivacypolicyurlGetPath = '/api/Roaming/privacypolicyurl';

  /**
   * Get a link to the privacy policy for the specified appType type and language.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingPrivacypolicyurlGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingPrivacypolicyurlGet$Response(params?: ApiRoamingPrivacypolicyurlGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiRoamingPrivacypolicyurlGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a link to the privacy policy for the specified appType type and language.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingPrivacypolicyurlGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingPrivacypolicyurlGet(params?: ApiRoamingPrivacypolicyurlGet$Params, context?: HttpContext): Observable<string> {
    return this.apiRoamingPrivacypolicyurlGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiRoamingMukUrlsGet()` */
  static readonly ApiRoamingMukUrlsGetPath = '/api/Roaming/MukUrls';

  /**
   * Obtaining a list of addresses for regional MUK services.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingMukUrlsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingMukUrlsGet$Response(params?: ApiRoamingMukUrlsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MukUrlApiRoaming>>> {
    return apiRoamingMukUrlsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Obtaining a list of addresses for regional MUK services.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingMukUrlsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingMukUrlsGet(params?: ApiRoamingMukUrlsGet$Params, context?: HttpContext): Observable<Array<MukUrlApiRoaming>> {
    return this.apiRoamingMukUrlsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<MukUrlApiRoaming>>): Array<MukUrlApiRoaming> => r.body)
    );
  }

  /** Path part for operation `apiRoamingWhatsnewurlGet()` */
  static readonly ApiRoamingWhatsnewurlGetPath = '/api/Roaming/whatsnewurl';

  /**
   * Getting the address of the What's new page.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingWhatsnewurlGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingWhatsnewurlGet$Response(params?: ApiRoamingWhatsnewurlGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiRoamingWhatsnewurlGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting the address of the What's new page.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingWhatsnewurlGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingWhatsnewurlGet(params?: ApiRoamingWhatsnewurlGet$Params, context?: HttpContext): Observable<string> {
    return this.apiRoamingWhatsnewurlGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiRoamingFaqGet()` */
  static readonly ApiRoamingFaqGetPath = '/api/Roaming/faq';

  /**
   * Get the faq link for the specified application type and language.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingFaqGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingFaqGet$Response(params?: ApiRoamingFaqGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiRoamingFaqGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the faq link for the specified application type and language.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingFaqGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingFaqGet(params?: ApiRoamingFaqGet$Params, context?: HttpContext): Observable<string> {
    return this.apiRoamingFaqGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiRoamingHowtoUrlsGet()` */
  static readonly ApiRoamingHowtoUrlsGetPath = '/api/Roaming/HowtoUrls';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiRoamingHowtoUrlsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingHowtoUrlsGet$Response(params?: ApiRoamingHowtoUrlsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return apiRoamingHowtoUrlsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiRoamingHowtoUrlsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiRoamingHowtoUrlsGet(params?: ApiRoamingHowtoUrlsGet$Params, context?: HttpContext): Observable<string> {
    return this.apiRoamingHowtoUrlsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
